import React from 'react';

const ShortFieldSelections = ({ actionPlayerId, handleFieldScore, handleFieldLocation, basketballFieldImg }) => {
  return (
    <div className="max-w-[260px] lg:max-w-[893px] w-full bg-[#4A4A4ACC] absolute z-40 right-0 flex justify-center items-center min-h-screen">
      <div className="max-w-[240px] lg:max-w-[841px] w-full bg-white rounded-[4px] lg:rounded-lg p-[10px] lg:p-[38px]">
        <p className="text-center text-[#4A4A4A] font-bebas text-xl lg:text-4xl ">
          Choose location of Action
        </p>
        <div
          className="w-full flex justify-center items-center my-5"
        // onClick={() => }
        >
          {/* <IconCollection name="basketball-field" /> */}
          <img
            onClick={(event) => {
              handleFieldScore(actionPlayerId);
              handleFieldLocation(event);
            }}
            className="cursor-crosshair max-w-[602px] w-full h-[150px] lg:h-[324px] object-contain"
            src={basketballFieldImg}
            alt="basketball-field"

          />
        </div>
      </div>
    </div>
  );
};

export default ShortFieldSelections;